export type MenuItemType = {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
        variant: string;
        text: string;
    };
    parentKey?: string;
    target?: string;
    children?: MenuItemType[];
};

const SUPER_ADMIN_MENU_ITEMS: MenuItemType[] = [
    { key: 'NAVIGATION', label: 'Navigation', isTitle: true },
    {
        key: 'SETTINGS',
        label: 'Route Creation',
        isTitle: false,
        icon: 'uil-tachometer-fast',
        url: '/settings/',
    },
    {
        key: 'SCHEDULE',
        label: 'Schedule',
        isTitle: false,
        icon: 'uil-calender',
        url: '/schedule',
    },
    {
        key: 'DATA_VISUALIZATION',
        label: 'Data Visualisation',
        isTitle: false,
        icon: 'mdi mdi-chart-bar',
        url: '/data-view',
    },
    {
        key: 'SENSOR_CREATION',
        label: 'Sensor Creation',
        isTitle: false,
        icon: 'mdi mdi-radar',
        url: '/sensor',
    },
    {
        key: 'MULTICHANNEL_MAPPING',
        label: 'MultiChannel Mapping',
        isTitle: false,
        icon: 'mdi mdi-sitemap',
        url: '/multi-channel',
    },
    {
        key: 'USER_MANAGEMENT',
        label: 'User Management',
        isTitle: false,
        icon: 'mdi mdi-account-group',
        url: '/user',
    },
    // {
    //     key: 'OIL_ANALYSIS',
    //     label: 'Oil Analysis',
    //     isTitle: false,
    //     icon: 'mdi mdi-oil-temperature',
    //     url: '/oil-analysis',
    // },
];

const CUSTOMER_ADMIN_MENU_ITEMS: MenuItemType[] = [
    { key: 'NAVIGATION', label: 'Navigation', isTitle: true },
    {
        key: 'SETTINGS',
        label: 'Settings',
        isTitle: false,
        icon: 'uil-tachometer-fast',
        url: '/customer-admin-route',
    },
    {
        key: 'SCHEDULE',
        label: 'Schedule',
        isTitle: false,
        icon: 'uil-calender',
        url: '/customer-schedule',
    },
    {
        key: 'DATA_VISUALIZATION',
        label: 'Data Visualisation',
        isTitle: false,
        icon: 'mdi mdi-chart-bar',
        url: '/customer-data-view',
    },
    // {
    //     key: 'OIL_ANALYSIS',
    //     label: 'Oil Analysis',
    //     isTitle: false,
    //     icon: 'mdi mdi-oil-temperature',
    //     url: '/oil-analysis',
    // },
];

const ANALYST_CUSTOMER_MENU_ITEMS: MenuItemType[] = [
    { key: 'NAVIGATION', label: 'Navigation', isTitle: true },
    {
        key: 'DATA_VISUALIZATION',
        label: 'Data Visualisation',
        isTitle: false,
        icon: 'mdi mdi-chart-areaspline',
        url: '/data-view',
    },
];

const EMPLOYEE_MENU_ITEMS: MenuItemType[] = [
    { key: 'NAVIGATION', label: 'Navigation', isTitle: true },

    {
        key: 'SCHEDULE',
        label: 'Schedule',
        isTitle: false,
        icon: 'uil-calender',
        url: '/employee/schedule',
    },
];

export { SUPER_ADMIN_MENU_ITEMS, CUSTOMER_ADMIN_MENU_ITEMS, EMPLOYEE_MENU_ITEMS, ANALYST_CUSTOMER_MENU_ITEMS };
